import { useState } from 'react';

import { Button } from '@/components/Button';
import { Input } from '@/components/Inputs';
import Modal from '@/components/Modal/Modal';

interface DeclineReasonModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason?: string) => void;
  title?: string;
  reasonLabel?: string;
  reasonPlaceholder?: string;
  submitLabel?: string;
}

export function DeclineReasonModal({
  open,
  onClose,
  onConfirm,
  title = 'Decline Event',
  reasonLabel = 'Reason (Optional)',
  reasonPlaceholder = 'I’m away that weekend',
  submitLabel = 'Decline Event',
}: DeclineReasonModalProps) {
  const [reason, setReason] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onConfirm(reason.trim() || undefined);
    setReason('');
  };

  const handleClose = () => {
    setReason('');
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} title={title}>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <Input
          label={reasonLabel}
          placeholder={reasonPlaceholder}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
        <Button type="submit">{submitLabel}</Button>
      </form>
    </Modal>
  );
}
